<template>
  <div class="classes-list">
    <div class="nav-bar">
      <van-nav-bar title="选择赛区" right-text="" fixed left-arrow @click-left="onClickLeft" />
    </div>
    <div>
      <div class="content">
        <van-search v-model="searchVal" placeholder="请输入赛区名称" @search="searchGroup" @input="searchGroup" />
        <div class="class-item" v-for="item in classList" :key="item.id">
          <div class="ellipsis1 name">{{ item.tournamentRegionName }}赛区</div>
          <div class="ellipsis1 classSlogan">

          </div>
          <div class="more flex">
            <div>赛区人数：{{ item.number || 0 }}人</div>
            <van-button plain hairline type="info" @click="addJoinClass(item)" :disabled="item.status == 1">
              <!-- 0 加入赛区 1 加入按钮禁用 2 加入按钮变为查看详情 -->
              {{ item.status == 0 ? '加入赛区' : '查看详情' }}
            </van-button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import Vue from 'vue'
import NavBar from 'vant/lib/nav-bar';
import 'vant/lib/nav-bar/style';
import Button from 'vant/lib/button';
import 'vant/lib/button/style';
import Search from 'vant/lib/search';
import 'vant/lib/search/style';
import Dialog from 'vant/lib/dialog';
import 'vant/lib/dialog/style';
import { updateObj } from '@/api/activity/index'

Vue.use(Search)
Vue.use(NavBar)
Vue.use(Button)
import { getInteractGroupList } from '@/api/activity'
export default {
  data() {
    return {
      searchVal: '',
      classList: []
    }
  },
  mounted() {
    document.title = '山西省第四届家庭教育指导技能大赛报名'
    this.loadGroupList()
  },

  methods: {
    toPage(pageName, params) {
      this.$router.push({ name: pageName, query: params })
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    // 加载赛区列表
    loadGroupList() {
      const params = {
        tournamentRegionName: this.searchVal || null,
        number: null,
        type: localStorage.getItem('signupType') || null,
        activityEntryId: this.$route.query.id || null,
      };
      getInteractGroupList(params).then(response => {
        this.classList = response.data || [];
      }).catch(() => {
        this.classList = [];
      });
    },
    // 搜索赛区
    searchGroup() {
      this.loadGroupList();
    },
    addJoinClass(item) {
      if (item.status == 2) {
        this.toPage('communicationgroup', { id: item.id })
        return
      }




      Dialog.confirm({
        title: '',
        message: '确定加入该赛区？',
      })
        .then(() => {
          updateObj({
            interactGroupId: item.id,//赛区沟通群id
            id: this.$route.query.id,//新增返回的id
          }).then(resp => {
            if (resp.code === 200) {
              // this.$toast('加入成功')
              this.toPage('communicationgroup', { id: item.id })
            }
          }).catch(() => {
            // this.$toast('加入失败')
          })
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
    }


  },

}
</script>

<style lang="scss" scoped>
.classes-list {
  .nav-bar {
    ::v-deep .van-icon {
      color: #000;
      font-size: 18px;
    }
  }

  .content {
    padding-top: 48px;

    .class-item {
      padding: 21px 16px;
      border-bottom: 1px solid #eee;
      font-size: 13px;

      .name {
        font-size: 14px;
      }


      .ellipsis1 {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .classSlogan {
        color: #999;
        font-size: 12px;
        margin-top: 10px;
      }

      .more {
        margin-top: 10px;

        &>div:first-child {
          color: #555;
        }

        .add-class {
          color: #4d83ef;
          border: 1px solid #4d83ef;
          padding: 5px;
          border-radius: 2px;
        }
      }

      .flex {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
      }
    }
  }
}
</style>
